import { Container, Row, Col, Typo } from '@geberit/gdds';

// styles
import styles from './quote.module.scss';
import { textStyle } from './styles';

// components
import { FontWeights } from 'components/ContentElements/Headline';

// utils
import { decodingContent } from 'utils/decodingContent';
import { classNameBuilder } from 'utils/classNameBuilder';
import { useSectionId } from 'utils/hooks/use-section-id';

export interface QuoteProps {
  quote: string;
  source?: string;
  contentIndex?: number;
  backgroundColor?: string;
}

export function Quote({
  quote,
  source,
  contentIndex,
  backgroundColor = 'white',
}: Readonly<QuoteProps>) {
  const parsedQuote = decodingContent(quote);
  const parsedSource = decodingContent(source);
  const sectionId = useSectionId('', '', false, contentIndex);

  return (
    <div
      className={classNameBuilder(styles.quoteWrapper, styles[`${backgroundColor}Background`])}
      id={sectionId}
    >
      <Container maxContentWidth="65rem">
        <Row>
          <Col size={[4, 8, 12]}>
            <div className={styles.text}>
              <Typo
                size={textStyle.quote}
                fontWeight={FontWeights.light}
                className={styles.quote}
                previewId="#st_quote"
              >
                {parsedQuote}
              </Typo>
              <Typo
                size={textStyle.source}
                fontWeight={FontWeights.bold}
                className={styles.source}
                previewId="#st_source"
              >
                {parsedSource}
              </Typo>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
